import _regeneratorRuntime from "/Users/mark/g/maejohns/www/maejohns.com/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/mark/g/maejohns/www/maejohns.com/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/mark/g/maejohns/www/maejohns.com/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/mark/g/maejohns/www/maejohns.com/node_modules/@babel/runtime/helpers/esm/createClass";
import * as forge from 'node-forge';
import { Buffer } from 'buffer';
import * as jose from 'node-jose';
import { log } from '../util/logger';
/**
 * Asynchronously generates a 1024-bit PEM-formatted keypair.
 * This function will run computations in steps to avoid locking
 * the main/UI thread, so it is safe to call at any time (though
 * too many invocations may overhead the mobile device!)
 */

export function generateKeypair() {
  return new Promise(function (resolve, reject) {
    try {
      // HARDCODED -- these values work and keeping for reference (RRS 2018-03-01)...
      // resolve({
      //     publicKey:
      //         '-----BEGIN RSA PUBLIC KEY-----\nMIIBCgKCAQEAsNucFVtd1IUggTM6qa/1n/lsXWt5j6XUzdj+Hs19JN7Z693axa7UC7UtBfB4\n0YL7fSqHiB2X6gwlXD2spwL7yU+kkai8lEyZJ40GNkyWDv58jVWnK1z5U+rMJ/nV8tXc5awy\n73MiYJuBoc1H85tlsatO4KWqbE4z8wbpNp6sHF6JVjanI7+LE9c6uiH7dFg1gRQPV1TloPFv\nRTqAlK8EfY0XS/wCmqJogbrhFve4sHHabFaCK5k9QTxV1L7GtzCmia9IlmdiQYrU2VPUmrir\njmeU0v99EkawyKAJPnLi5qnzHvjeWHGiPlB+zlsQ3iXQdEPBBjmV93No0fTpy49aawIDAQAB\n-----END RSA PUBLIC KEY-----\n',
      //     privateKey:
      //         '-----BEGIN RSA PRIVATE KEY-----\nMIIEpQIBAAKCAQEAsNucFVtd1IUggTM6qa/1n/lsXWt5j6XUzdj+Hs19JN7Z693axa7UC7Ut\nBfB40YL7fSqHiB2X6gwlXD2spwL7yU+kkai8lEyZJ40GNkyWDv58jVWnK1z5U+rMJ/nV8tXc\n5awy73MiYJuBoc1H85tlsatO4KWqbE4z8wbpNp6sHF6JVjanI7+LE9c6uiH7dFg1gRQPV1Tl\noPFvRTqAlK8EfY0XS/wCmqJogbrhFve4sHHabFaCK5k9QTxV1L7GtzCmia9IlmdiQYrU2VPU\nmrirjmeU0v99EkawyKAJPnLi5qnzHvjeWHGiPlB+zlsQ3iXQdEPBBjmV93No0fTpy49aawID\nAQABAoIBAGE9Da9MYeWUIJAI26sqfNEtMSCYE+kgE0XulaHX94OLJ6QggcWI3ztkrNGEKtl+\nu8lQ1d3H75uWfAAgRMo6wLcpm+EeNjkPeHGffxfhueuajl6jBlu4Lbmu8frUyYZPgbmhmQvA\ncNlPBtIwbOwKt7oc5yxqya3svXFUjmsiiJy7jtkPYYhq7KncSGbcRN5vWGJ/O4O4hILBhs0J\nWBDfiqfT0nzP1ZXQJ1Aq5khvI56fY4ujoGfXQMoHRKC+SUPjiLNPo3SDFw26iuJbWG4tCM0z\nx35mJIyoTYr2b78QvvtFDc/1ToDJFF+EuGHzT/2uF86dfxX7cpSEeezWRpbtxkECgYEA50wj\nlglN09oRSnSMNQjvGF2bW3n4LxgJuRkPlEcP+ZFFCQ3BHYqTSVmjYKmwi3Nwo5JWg3YyQbF3\nIXtyqrBVdaOuTqO4czf9F87bGhRyi6xRAzC6V12/uzQ4LVfe8UU6lfqH4xNERyKhvkb/5FUO\ngKKPraUEueovvk0JpaVnk4sCgYEAw78MXOr7c7ZTBRK0So9jAyMIonOfywIfnu+99YfRXFxA\n70Fjqk2YBsOlPggyqlSmFui6AdpFPQrtmoqRfF752atWt2B3gbotRmNBkezVJbqC7Fu7K1OL\nGZAHh6El9Q4OlZwPhHH13itlt63COC/mOtHtuXtY/VR6/IhQRr90sKECgYEAo+5J1n/3oiwP\nTzb1XG1dkGZfwuDabv5Zfc/uQ8ht4RL92+HcukRKCZW3fr4l+2AxOC1ylbADBJ5z8c4dwi5C\nE6OT2fadt0O6ZNJeZciSOr5BmMJDf8JZLqRfIHwD7fqEAGJVRzKTlNtNyZ9mo/1IzxDoRkkL\n5Xy+o+DT8owdsesCgYEAq8k/pVAHqy4oP7yBgynBQCB/1Gnao4PSkl5d/Fvcjczco9xkBjKg\np9cNbpotNLSjKlnF3BhdSUwM5+KR+W80oCWxLa+4UZ49W5eCFPmeucSsX5fFdCmWWrG/GfV/\n5UcX346dQ6PrnbXCR+dzGnJW/+n6UhyBJZn9cSCEKwKc+uECgYEAvC7QOEUQrdx+HEzUD0wr\nGwJxiraFfLLuJN8iecD8/R7yweX2MJVtw0GPPCbT0f0N78/FtCsDjMfNDNi2uaBlkh03yJKc\nK73xLV4G8MeFH9A2buAstvS1Iz5PpspvUTTNYgmgb3Xsv6A6IMYi/DZ+WCKxmlJ0M2V7v85T\nz2rAZiE=\n-----END RSA PRIVATE KEY-----\n',
      // })
      var state = forge.pki.rsa.createKeyPairGenerationState(768, 0x10001);

      var step = function step() {
        // run for 100 ms
        if (!forge.pki.rsa.stepKeyPairGenerationState(state, 100)) {
          setTimeout(step, 1);
        } else {
          // log.info(`keypair generation took ${Date.now() - start} ms`);
          var privateKey = forge.pki.privateKeyToPem(state.keys.privateKey);
          var publicKey = forge.pki.publicKeyToPem(state.keys.publicKey); // log.info(`public key: ${publicKey}`);

          resolve({
            privateKey: privateKey,
            publicKey: publicKey
          });
        }
      };

      setTimeout(step);
    } catch (e) {
      reject(e);
    }
  });
}
export var KeySet =
/*#__PURE__*/
function () {
  function KeySet(keystore) {
    _classCallCheck(this, KeySet);

    this._keystore = jose.JWK.createKeyStore();
    this._keystore = keystore || this._keystore;
  }

  _createClass(KeySet, [{
    key: "hasKeys",
    value: function hasKeys() {
      return this._keystore.all({}).length > 0;
    }
  }, {
    key: "all",
    value: function all() {
      var includePrivate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return this._keystore.all({}).map(function (jwk) {
        return {
          jwk: jwk.toJSON(includePrivate),
          pem: jwk.toPEM(includePrivate)
        };
      });
    }
  }, {
    key: "allKIDs",
    value: function allKIDs() {
      var includePrivate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return this.all(includePrivate).filter(function (key) {
        return key.jwk.kid;
      }).map(function (key) {
        return key.jwk.kid;
      });
    }
  }, {
    key: "encryptionKeys",
    value: function encryptionKeys() {
      var includePrivate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return this._keystore.all({
        use: 'enc'
      }).map(function (jwk) {
        return {
          jwk: jwk.toJSON(includePrivate),
          pem: jwk.toPEM(includePrivate)
        };
      });
    }
  }, {
    key: "signingKeys",
    value: function signingKeys() {
      var includePrivate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return this._keystore.all({
        use: 'sig'
      }).map(function (jwk) {
        return {
          jwk: jwk.toJSON(includePrivate),
          pem: jwk.toPEM(includePrivate)
        };
      });
    }
    /** Export the full KeySet INCLUDING PRIVATE KEYS as a JWKSet */

  }, {
    key: "toString",
    value: function toString() {
      return JSON.stringify(this._keystore.toJSON(true));
    }
  }, {
    key: "getPublicKey",
    value: function getPublicKey(kid) {
      var k = this._keystore.get(kid);

      if (k) {
        return k.toJSON();
      }

      return undefined;
    }
  }, {
    key: "getPublicKeyPEM",
    value: function getPublicKeyPEM(kid) {
      return this._keystore.get(kid).toPEM();
    }
  }, {
    key: "hasPrivateKey",
    value: function hasPrivateKey(kid) {
      return Boolean(this._keystore.get(kid));
    }
  }, {
    key: "getPrivateKey",
    value: function getPrivateKey(kid) {
      return this._keystore.get(kid).toJSON(true);
    }
  }, {
    key: "getPrivateKeyPEM",
    value: function getPrivateKeyPEM(kid) {
      return this._keystore.get(kid).toPEM(true);
    }
  }, {
    key: "addSigningKey",
    value: function addSigningKey(privateKey) {
      var props = {
        use: 'sig',
        key_ops: ['sign', 'verify'],
        alg: 'PS256'
      };
      return this._keystore.add(privateKey, 'pem', props);
    }
  }, {
    key: "addEncryptionKey",
    value: function addEncryptionKey(privateKey) {
      var props = {
        use: 'enc',
        key_ops: ['encrypt', 'decrypt', 'wrapKey', 'unwrapKey'],
        alg: 'RSA-OAEP'
      };
      return this._keystore.add(privateKey, 'pem', props);
    }
  }, {
    key: "addEncryptionPublicKey",
    value: function addEncryptionPublicKey(publicKey) {
      var props = {
        use: 'enc',
        key_ops: ['encrypt', 'decrypt', 'wrapKey', 'unwrapKey'],
        alg: 'RSA-OAEP'
      };
      return this._keystore.add(publicKey, 'pem', props);
    }
  }, {
    key: "addJWK",
    value: function addJWK(jwk) {
      return this._keystore.add(jwk, 'json');
    }
  }, {
    key: "addJWKs",
    value: function () {
      var _addJWKs = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(jwks) {
        var promises, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, jwk;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                promises = [];
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 4;
                _iterator = jwks[Symbol.iterator]();

              case 6:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 16;
                  break;
                }

                jwk = _step.value;
                _context.t0 = promises;
                _context.next = 11;
                return this._keystore.add(jwk);

              case 11:
                _context.t1 = _context.sent;

                _context.t0.push.call(_context.t0, _context.t1);

              case 13:
                _iteratorNormalCompletion = true;
                _context.next = 6;
                break;

              case 16:
                _context.next = 22;
                break;

              case 18:
                _context.prev = 18;
                _context.t2 = _context["catch"](4);
                _didIteratorError = true;
                _iteratorError = _context.t2;

              case 22:
                _context.prev = 22;
                _context.prev = 23;

                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return();
                }

              case 25:
                _context.prev = 25;

                if (!_didIteratorError) {
                  _context.next = 28;
                  break;
                }

                throw _iteratorError;

              case 28:
                return _context.finish(25);

              case 29:
                return _context.finish(22);

              case 30:
                return _context.abrupt("return", Promise.all(promises));

              case 31:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 18, 22, 30], [23,, 25, 29]]);
      }));

      return function addJWKs(_x) {
        return _addJWKs.apply(this, arguments);
      };
    }()
  }, {
    key: "encrypt",
    value: function () {
      var _encrypt = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(data, keyThumbprint) {
        var key, result;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                key = this._keystore.get(keyThumbprint, {
                  kty: 'RSA',
                  use: 'enc'
                });
                _context2.next = 3;
                return jose.JWE.createEncrypt({
                  format: 'compact'
                }, key).update(data).final();

              case 3:
                result = _context2.sent;

                if (!(typeof result !== 'string')) {
                  _context2.next = 6;
                  break;
                }

                throw new Error('JWE Compact Serialization did not return string');

              case 6:
                return _context2.abrupt("return", result);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      return function encrypt(_x2, _x3) {
        return _encrypt.apply(this, arguments);
      };
    }()
  }, {
    key: "encryptString",
    value: function () {
      var _encryptString = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(data) {
        var kid, b, jwe;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                kid = this.encryptionKeys()[0].jwk.kid;
                b = Buffer.from(data, 'utf8');
                _context3.next = 4;
                return this.encrypt(b, kid);

              case 4:
                jwe = _context3.sent;
                return _context3.abrupt("return", jwe);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      return function encryptString(_x4) {
        return _encryptString.apply(this, arguments);
      };
    }()
  }, {
    key: "decrypt",
    value: function () {
      var _decrypt = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(jwe) {
        var result;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return jose.JWE.createDecrypt(this._keystore).decrypt(jwe);

              case 3:
                result = _context4.sent;
                return _context4.abrupt("return", result);

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4["catch"](0);

              case 9:
                return _context4.abrupt("return", undefined);

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 7]]);
      }));

      return function decrypt(_x5) {
        return _decrypt.apply(this, arguments);
      };
    }()
  }, {
    key: "exportPublicJWKSet",
    value: function exportPublicJWKSet() {
      // JWKSet
      return this._keystore.toJSON();
    }
  }, {
    key: "signMessageJWSCompact",
    value: function signMessageJWSCompact(msg, kid) {
      var key = this._keystore.get(kid); // We know this returns a string because of the format argument


      return jose.JWS.createSign({
        format: 'compact',
        fields: {
          timestamp: Date.now()
        }
      }, [key]).update(msg, 'utf8').final();
    }
  }, {
    key: "signMessageJWSJson",
    value: function signMessageJWSJson(msg, kid) {
      var key = this._keystore.get(kid); // We know this returns a `JWSJson` because we did not request a compact format


      return jose.JWS.createSign([key]).update(msg).final();
    }
  }, {
    key: "addSignaturesToJWS",
    value: function addSignaturesToJWS(jwsjson, keyThumbprints) {
      var keys = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = keyThumbprints[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var thumbprint = _step2.value;
          keys.push({
            key: this._keystore.get(thumbprint, {
              kty: 'RSA',
              use: 'sig'
            })
          });
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      var data = jose.util.base64url.decode(jwsjson.payload);
      return jose.JWS.createSign(keys).update(data).final().then(function (result) {
        jwsjson.signatures = jwsjson.signatures.concat(result.signatures);
        return jwsjson;
      });
    }
  }, {
    key: "readJWEArray",
    value: function () {
      var _readJWEArray = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(jwes) {
        var _this = this;

        var promises, results;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                promises = jwes.map(function (jwe) {
                  return _this.decrypt(jwe);
                });
                _context5.next = 3;
                return Promise.all(promises);

              case 3:
                results = _context5.sent;
                return _context5.abrupt("return", results.filter(function (r) {
                  return !!r;
                }).map(function (r) {
                  return r.plaintext.toString('utf8');
                }));

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      return function readJWEArray(_x6) {
        return _readJWEArray.apply(this, arguments);
      };
    }()
  }, {
    key: "keyStore",
    get: function get() {
      return this._keystore;
    }
  }], [{
    key: "create",
    value: function () {
      var _create = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(jwkSet) {
        var keystore;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return jose.JWK.asKeyStore(jwkSet);

              case 2:
                keystore = _context6.sent;
                return _context6.abrupt("return", new KeySet(keystore));

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      return function create(_x7) {
        return _create.apply(this, arguments);
      };
    }()
  }, {
    key: "encryptToKey",
    value: function () {
      var _encryptToKey = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7(data, key) {
        var ks, k, b, jwe;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                ks = new KeySet();
                _context7.next = 3;
                return ks.addJWK(JSON.parse(key));

              case 3:
                k = _context7.sent;
                b = Buffer.from(data, 'utf8');
                _context7.next = 7;
                return ks.encrypt(b, k.kid);

              case 7:
                jwe = _context7.sent;
                return _context7.abrupt("return", jwe);

              case 9:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      return function encryptToKey(_x8, _x9) {
        return _encryptToKey.apply(this, arguments);
      };
    }()
  }, {
    key: "encryptToRecipients",
    value: function () {
      var _encryptToRecipients = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8(data, keys) {
        var databuf, encryptor, result;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                databuf = Buffer.from(data, 'utf8');
                encryptor = jose.JWE.createEncrypt({
                  protect: [],
                  format: 'general'
                }, keys).update(databuf);
                _context8.next = 4;
                return encryptor.final();

              case 4:
                result = _context8.sent;

                if (!(typeof result === 'string')) {
                  _context8.next = 7;
                  break;
                }

                throw new Error('JWE JSON Serialization returned string');

              case 7:
                return _context8.abrupt("return", result);

              case 8:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      return function encryptToRecipients(_x10, _x11) {
        return _encryptToRecipients.apply(this, arguments);
      };
    }()
  }, {
    key: "verifyJWS",
    value: function () {
      var _verifyJWS = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9(jws, publicJWK) {
        var keystore;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                keystore = jose.JWK.createKeyStore();
                _context9.next = 3;
                return keystore.add(publicJWK, 'json');

              case 3:
                return _context9.abrupt("return", jose.JWS.createVerify(keystore).verify(jws).then(function (result) {
                  if (result) {}

                  return !!result;
                }).catch(function () {
                  return false;
                }));

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      return function verifyJWS(_x12, _x13) {
        return _verifyJWS.apply(this, arguments);
      };
    }()
  }, {
    key: "generateSymmetricKey",
    value: function () {
      var _generateSymmetricKey = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10() {
        var props, keystore;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                props = {
                  alg: 'A256GCM',
                  use: 'enc'
                };
                keystore = jose.JWK.createKeyStore();
                return _context10.abrupt("return", keystore.generate('oct', 256, props));

              case 3:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      return function generateSymmetricKey() {
        return _generateSymmetricKey.apply(this, arguments);
      };
    }()
  }]);

  return KeySet;
}();
export function passwordEncrypt(_x14, _x15) {
  return _passwordEncrypt.apply(this, arguments);
}

function _passwordEncrypt() {
  _passwordEncrypt = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee11(data, password) {
    var props, key, result;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            props = {
              kty: 'oct',
              alg: 'PBES2-HS256+A128KW',
              iterations: 1024,
              p2c: 1024,
              use: 'enc',
              k: jose.util.base64url.encode(new Buffer(password), 'utf8')
            };
            _context11.next = 3;
            return jose.JWK.asKey(props);

          case 3:
            key = _context11.sent;
            log.debug('generated key', {
              iterations: key.toJSON().iterations,
              k: key.toJSON()
            });
            _context11.next = 7;
            return jose.JWE.createEncrypt({
              format: 'compact'
            }, key).update(new Buffer(data, 'utf8')).final();

          case 7:
            result = _context11.sent;
            return _context11.abrupt("return", result);

          case 9:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11, this);
  }));
  return _passwordEncrypt.apply(this, arguments);
}

export function passwordDecrypt(_x16, _x17) {
  return _passwordDecrypt.apply(this, arguments);
}

function _passwordDecrypt() {
  _passwordDecrypt = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee12(jwecompact, password) {
    var parts, header, props, key, decryptResult;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            parts = jwecompact.split('.');
            header = JSON.parse(jose.util.base64url.decode(parts[0]).toString());
            props = {
              kty: 'oct',
              alg: header.alg,
              use: 'enc',
              k: jose.util.base64url.encode(new Buffer(password), 'utf8')
            };
            _context12.next = 5;
            return jose.JWK.asKey(props).catch(function (e) {
              throw log.error('Error deriving key from password', {
                e: e,
                parts: parts
              });
            });

          case 5:
            key = _context12.sent;
            _context12.next = 8;
            return jose.JWE.createDecrypt(key).decrypt(jwecompact).catch(function (e) {
              throw log.error('Error decrypting with derived key', {
                e: e,
                parts: parts
              });
            });

          case 8:
            decryptResult = _context12.sent;
            return _context12.abrupt("return", decryptResult.payload.toString('utf8'));

          case 10:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12, this);
  }));
  return _passwordDecrypt.apply(this, arguments);
}

export function encrypt(_x18, _x19) {
  return _encrypt2.apply(this, arguments);
}

function _encrypt2() {
  _encrypt2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee13(data, sk) {
    var key, encryptResult;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            _context13.next = 2;
            return jose.JWK.asKey(sk);

          case 2:
            key = _context13.sent;
            _context13.next = 5;
            return jose.JWE.createEncrypt({
              format: 'compact'
            }, key).update(new Buffer(data, 'utf8')).final();

          case 5:
            encryptResult = _context13.sent;
            return _context13.abrupt("return", encryptResult);

          case 7:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13, this);
  }));
  return _encrypt2.apply(this, arguments);
}

export function decrypt(_x20, _x21) {
  return _decrypt2.apply(this, arguments);
} // TODO remove this in favor of computeDigest

function _decrypt2() {
  _decrypt2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee14(jwecompact, sk) {
    var key, decryptResult;
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            _context14.next = 2;
            return jose.JWK.asKey(sk);

          case 2:
            key = _context14.sent;
            _context14.next = 5;
            return jose.JWE.createDecrypt(key).decrypt(jwecompact);

          case 5:
            decryptResult = _context14.sent;
            return _context14.abrupt("return", decryptResult.payload.toString('utf8'));

          case 7:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14, this);
  }));
  return _decrypt2.apply(this, arguments);
}

export function hash(data) {
  var md = forge.md.sha256.create();
  md.update(data);
  var bs = new Buffer(md.digest().data);
  return jose.util.base64url.encode(bs, 'utf8');
}
export function computeDigest(s) {
  var md = forge.md.sha256.create();
  md.update(s);
  var buf = Buffer.from(md.digest().getBytes(), 'binary');
  return jose.util.base64url.encode(buf, 'binary');
}
export function isSignerObject(si) {
  return !!si.key;
}
export * from './jwefields';